import * as React from "react";
import TableCell from "@mui/material/TableCell";

const EmptyCheckBoxCell = () => {
    return (
        <TableCell padding="checkbox" />
    );
};

export default EmptyCheckBoxCell;